import {WhatsAppOutlined} from '@ant-design/icons';
import {Button, Form, Input, Select, message} from 'antd';

import data from '../../data/data.json'; // adjust path as needed

const {TextArea} = Input;
const {Option} = Select;

const Careers = () => {
  const careersData = data.careers;
  const positions = careersData.positions || [];

  const onFinish = values => {
    const {name, email, position, message: msg} = values;

    const whatsappNumber = careersData.whatsappNumber;
    const text = `Hello, I'm interested in applying for the position of *${position}* at your Volume_9 company.%0A
*Name:* ${name}%0A
*Email:* ${email}%0A
*Message:* ${msg || 'N/A'}`;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${text}`;
    window.open(whatsappURL, '_blank');
    message.success('Opening WhatsApp...');
  };

  return (
    <div className={'w-full flex flex-col items-center justify-center lg:px-20 px-6 lg:py-20 py-10 bg-[#ffffff]'}>
      <div className={'max-w-7xl w-full'}>
        {/* --- Header + Form Section --- */}
        <div className={'flex flex-col lg:flex-row rounded-3xl shadow-xl overflow-hidden '}>
          {/* --- Image Section with Overlay Text --- */}
          <div
            className={'relative flex flex-col  lg:items-start text-center lg:text-left lg:w-1/2 w-full h-[500px] lg:h-auto'}
            style={{
              backgroundImage: 'url(\'/careerbg.jpg\')', 
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            {/* Overlay for better contrast */}
            <div className={'absolute inset-0 bg-black/50'}></div>

            {/* Text on top of image */}
            <div className={'relative z-10 p-10  text-white'}>
              <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl mb-8 text-primary-50 '}>
                {careersData.title}
              </h1>
              <p className={'md:text-xl text-gray-200 max-w-xl text-bold'}>
                {careersData.description}
              </p>
            </div>
          </div>

          {/* Form  */}
          <div className={'bg-primary-50 p-10 flex flex-col justify-center lg:w-1/2 w-full'}>
            <h2 className={'playfair-display-medium md:text-5xl text-2xl font-bold  text-center text-primary-800 mb-8'}>
              Apply Now
            </h2>

            <Form layout={'vertical'} onFinish={onFinish} requiredMark={false}>
              <div className={'flex flex-col lg:flex-row gap-4'}>
                <Form.Item
                  label={'Full Name'}
                  name={'name'}
                  className={'w-full'}
                  rules={[{required: true, message: 'Please enter your name'}]}
                >
                  <Input placeholder={'Your full name'} />
                </Form.Item>

                <Form.Item
                  label={'Email Address'}
                  name={'email'}
                  className={'w-full'}
                  rules={[{required: true, message: 'Please enter your email'}]}
                >
                  <Input placeholder={'example@email.com'} />
                </Form.Item>
              </div>

              <Form.Item
                label={'Position Applying For'}
                name={'position'}
                rules={[{required: true, message: 'Please select a position'}]}
              >
                <Select
                  mode={'tags'}
                  maxCount={1}
                  placeholder={'Select or type position'}
                >
                  {positions.map(pos => (
                    <Option key={pos.id} value={pos.title}>
                      {pos.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label={'Message (optional)'} name={'message'}>
                <TextArea rows={4} placeholder={'Tell us a bit about yourself...'} />
              </Form.Item>

              <div className={'flex justify-center mt-6'}>
                <Button
                  type={'primary'}
                  htmlType={'submit'}
                  className={'!bg-primary-700 !text-white flex items-center gap-2'}
                >
                  <WhatsAppOutlined className={'text-lg'} /> Submit via WhatsApp
                </Button>
              </div>
            </Form>
          </div>
        </div>

        {/* --- Work Culture Highlights --- */}
        <div className={'text-center mt-20'}>
          <h3 className={'text-2xl playfair-display-medium font-semibold text-primary-800 mb-4'}>
            {careersData.highlights.title}
          </h3>
          <p className={'text-gray-600 max-w-3xl mx-auto'}>
            {careersData.highlights.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Careers;
